<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="拍摄完成时间">
            <form-date-range
              :form="searchForm"
              startKey="endTimeStart"
              endKey="endTimeEnd"
              :usingTime="false"
              valueFormat="yyyyMMdd"
            ></form-date-range>
          </el-form-item>
          <el-form-item label="SPU品类">
            <el-select v-model="searchForm.spuCategory" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in spuCategoryList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主导拍摄人员">
            <el-input v-model.trim="searchForm.userNameMain" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="辅助拍摄人员">
            <el-input v-model.trim="searchForm.userNameDeputy" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="产品类型">
            <el-select v-model="searchForm.productTypes" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in productTypeList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="SPU编码">
            <el-input v-model.trim="searchForm.spuCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="SPU名称">
            <el-input v-model.trim="searchForm.spuName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="SKU编码">
            <el-input v-model.trim="searchForm.skuCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="SKU名称">
            <el-input v-model.trim="searchForm.skuName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="产品编码">
            <el-input v-model.trim="searchForm.productCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input v-model.trim="searchForm.productName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="商品定位">
            <el-select v-model="searchForm.goodsLocation" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in goodsLocationList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column
          v-for="(item, index) in columnData"
          :key="item.columnName + index"
          :align="`${item.fieldType == 'string' ? 'left' : 'right'}`"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            {{ scope.row[item.columnName] | cellValFormat }}
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
  import pagePathMixin from '@/utils/page-path-mixin'
  import tableMixin from "@/utils/tableMixin";
  import axios from "@/utils/axiosInstance";
  
  export default {
  name: "photographySalaryAccounting",
  mixins: [tableMixin, pagePathMixin],
  components: {},
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: "newProductShootingAccountingBusinessInfo",
      columnData: [],
      loading: false,
      searchForm: {
        productTypes: "",
        spuCategory: "",
        goodsLocation: "",
        endTimeStart: "",
        endTimeEnd: "",
      },
      exportData: {},
      searchCollapse: false,
      queryCriteria: [],
      spuCategoryList: [],
      goodsLocationList: [],
      productTypeList: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {},
  methods: {
    columns() {
      this.loading = true;
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then((res) => {
        this.columnData = res.data.sysColumns;
        this.init();
      });
    },
    onSearch() {
      // 校验拍摄完成时间：可以都为空，但不能只填一个
      const start = this.searchForm.endTimeStart;
      const end = this.searchForm.endTimeEnd;
      if ((start && !end) || (!start && end)) {
        this.$message.warning('拍摄完成时间请选择完整的时间段');
        return;
      }
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "endTimeQuery", //拍摄完成时间
          val: start && end ? [start, end] : [],
          op: "range",
        },
        {
          attributeName: "spuCategory", //SPU品类
          val: [this.searchForm.spuCategory ? this.searchForm.spuCategory : ""],
          op: "in",
        },
        {
          attributeName: "userNameMain", //主导拍摄人员
          val: [this.searchForm.userNameMain ? this.searchForm.userNameMain : ""],
          op: "in",
        },
        {
          attributeName: "userNameDeputy", //辅助拍摄人员
          val: [this.searchForm.userNameDeputy ? this.searchForm.userNameDeputy : ""],
          op: "in",
        },
        {
          attributeName: "productTypes", //产品类型
          val: this.searchForm.productTypes ? this.searchForm.productTypes : "",
          op: "like",
        },
        {
          attributeName: "spuCode", //SPU编码
          val: [this.searchForm.spuCode ? this.searchForm.spuCode : ""],
          op: "in",
        },
        {
          attributeName: "spuName", //SPU名称
          val: this.searchForm.spuName ? this.searchForm.spuName : "",
          op: "like",
        },
        {
          attributeName: "skuCode", //SKU编码
          val: [this.searchForm.skuCode ? this.searchForm.skuCode : ""],
          op: "in",
        },
        {
          attributeName: "skuName", //SKU名称
          val: this.searchForm.skuName ? this.searchForm.skuName : "",
          op: "like",
        },
        {
          attributeName: "productCode", //产品编码
          val: [this.searchForm.productCode ? this.searchForm.productCode : ""],
          op: "in",
        },
        {
          attributeName: "productName", //产品名称
          val: this.searchForm.productName ? this.searchForm.productName : "",
          op: "like",
        },
        {
          attributeName: "goodsLocation", //商品定位
          val: [this.searchForm.goodsLocation ? this.searchForm.goodsLocation : ""],
          op: "in",
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            if (!type) {
              this.tableReload = false;
              this.$nextTick((_) => {
                this.tableReload = true;
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    reset() {
      if (this.$refs["table"]) {
        this.$refs["table"].clearSort(); //切换清除排序
      }
      this.searchForm = {
        productTypes: "",
        spuCategory: "",
        goodsLocation: "",
        endTimeStart: "",
        endTimeEnd: "",
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    //spu品类
    getSpuCategoryList() {
      let data = { ...this.currencyForm };
      data.reportCode = this.reportName;
      data.groupAttr = "spuCategory";
      data.hasCount = "Y";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.spuCategoryList = data;
      });
    },
    //商品定位
    getGoodsLocationList() {
      let data = { ...this.currencyForm };
      data.reportCode = this.reportName;
      data.groupAttr = "goodsLocation";
      data.hasCount = "Y";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.goodsLocationList = data;
      });
    },
    //获取配置页面的产品类型
    getProductTypeList() {
      let data = { ...this.currencyForm };
      data.reportCode = 'newProductShootingAccountingConfig';
      data.groupAttr = "productType";
      data.hasCount = "Y";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.productTypeList = data;
      });
    },

    // 导出
    exportExcel() {
      console.log(this.searchFormData);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-new",
          paramMap: {
            ...this.searchFormData,
          },
          reportName: this.reportName,
        },
        columnDTOs: [],
      };
      params.columnDTOs = this.columnData
        .map((item) => {
          return {
            columnName: item.displayName,
            fieldName: item.columnName,
            fieldType: "string",
            columnFormat: null,
          };
        })
        .filter((v) => v.columnName != "图片"); // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter((v) => v.columnName !== "图片");
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  mounted() {
    this.getSpuCategoryList()
    this.getGoodsLocationList()
    this.getProductTypeList()
    this.columns();
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important
</style>
